import JobDashboardCenterColumn from "../../../student/components/JobDashboardCenterColumn";

export default function EmpHomeMain() {
  return <JobDashboardCenterColumn />;
}
